var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgProductSiding(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.307.121a.983.983 0 00-.725-.03c-.867.3-3.056 1.063-4.376 1.562a.984.984 0 00-.52.46L6.137 6.913a1 1 0 00.436 1.363l1.205.603-1.645 3.837a1 1 0 00.523 1.312l1.25.54-1.538 3.287a1 1 0 00.435 1.306l8.797 4.685c.284.142.615.157.911.042l.528-.205.11-.043 6.112-2.377c.433-.168.717-.584.717-1.048v-15c0-.426-.24-.816-.622-1.007-2.076-.987-7.595-3.44-9.05-4.086zm4.34 20.521l3.082-1.198v-2.107l-1.758.66-1.323 2.645zm-1.737-1.555s-5.13-2.584-6.99-3.514l-1.094 2.188 6.925 3.643 1.159-2.317zm-8.212-6.64l1.097-2.561 6.975 3.668-1.097 2.561-6.975-3.668zm9.335 3.873l3.696-1.386V12.17l-2.35 1.007-1.346 3.143zM8.676 6.81l1.243-2.487 7.336 3.849-1.097 2.56-7.482-3.921zm9.758 4.324l3.295-1.412V7.034l-1.957.979-1.338 3.121zm1.905-5.92l-6.387-2.977-1.91.632 6.312 3.337 1.985-.992z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgProductSiding);
export default ForwardRef;
